require('./publicPath');
require('babel-polyfill');
require('es6-object-assign').polyfill();
require('es6-promise').polyfill();

require('string.prototype.startswith');
